module.exports = __webpack_public_path__ + "img/logo_new.9160c7fe.png";